module.exports = __webpack_public_path__ + "static/media/3_r_sculptura2_84.69_43.43.6fcdbe90.png";